import * as React from 'react';
import { FieldLabelWUT } from '../../field-label/field-label-wut';
import { ImageComponent } from './image-component';
import { classes } from './quiz-question-styles.st.css';
const DEFAULT_QUESTION_IMAGE_ASPECT_RATIO = 3 / 2;
export const QuizQuestionWut = props => {
  const {
    image,
    imagePlacement = 'bottom',
    imageResize = 'cover',
    imageAlignment,
    labelId,
    htmlFor,
    ...fieldLabelProps
  } = props;
  const Tag = props.htmlFor ? 'label' : 'div';
  const questionElement = /*#__PURE__*/React.createElement(FieldLabelWUT, fieldLabelProps);
  const imageElement = image ? /*#__PURE__*/React.createElement("div", {
    className: classes.imageContainer
  }, /*#__PURE__*/React.createElement(ImageComponent, {
    image: image,
    alt: props.imageAltText,
    aspectRatio: imageResize === 'cover' ? DEFAULT_QUESTION_IMAGE_ASPECT_RATIO : Math.max(image.width / image.height, DEFAULT_QUESTION_IMAGE_ASPECT_RATIO),
    imageAlignment: imageResize === 'cover' ? 'center' : imageAlignment,
    imageResize: imageResize
  })) : null;
  return /*#__PURE__*/React.createElement(Tag, {
    id: labelId,
    htmlFor: htmlFor,
    className: classes.root
  }, imagePlacement === 'top' ? imageElement : null, questionElement, imagePlacement === 'bottom' ? imageElement : null);
};
//# sourceMappingURL=quiz-question-wut.js.map